<template>
    <div class="us_app">
        <Gnb/>
        <slot></slot>
        <Footer />
    </div>
</template>

<script>
    import Gnb from "@/components/user/UserGnb.vue"    
    import Footer from "@/components/user/UserFooter.vue"

export default {
  name: "userMainLayout",
  components: {
    Gnb,    
    Footer    
  },
  created(){ console.log("@@@@@ userLayout")}
};
</script>


